module.exports = __webpack_public_path__ + "img/appIcon-apps--Purchases.271b8da6.svg";